import React, { useEffect, useState } from "react";
import Innerhtml from "./Innerhtml";

export default function ContentPage({
  heading,
  subHeading,
  content,
  image,
  imageAlt = "Content image",
}) {
  const [animationComplete, setAnimationComplete] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimationComplete(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="container mx-auto relative overflow-hidden py-10">
      <div className="relative z-10">
        <div className="bg-olive-800 relative px-6 py-4">
          <h1 className="text-center text-2xl font-semibold text-amber-400">
            {heading}
          </h1>
          <div className="absolute bottom-0 left-0 right-0 h-1 bg-amber-400" />
        </div>

        {image ? (
          <div className="flex flex-col gap-6 bg-gray-100 p-6 md:flex-row md:p-8">
            <div className="w-full md:w-1/3">
              <img
                src={image}
                alt={imageAlt}
                className="w-full rounded-md object-cover"
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="w-full md:w-2/3">
              {subHeading && (
                <p className="mb-6 text-gray-800">{subHeading}</p>
              )}
              <Innerhtml data={content} />
            </div>
          </div>
        ) : (
          <div className="bg-gray-100 p-6 md:p-8">
            {subHeading && <p className="mb-6 text-gray-800">{subHeading}</p>}
            <Innerhtml data={content} />
          </div>
        )}
      </div>

      {!animationComplete && (
        <>
          <div className="curtain-left" />
          <div className="curtain-right" />
        </>
      )}
    </div>
  );
}
